import React, { useState, useMemo } from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import DataTable from 'components/shared/DataTable';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { COUPON_PERMISSION } from 'pages/Coupon/utils/constants';
import { showConfirmModal } from 'actions/global';
import { useDispatch } from 'react-redux';
import CouponCustomerTypeModal from './modal/CouponCustomerTypeModal';
import ICON_COMMON from 'utils/icons.common';
import PropTypes from 'prop-types';

const CouponCustomerType = ({ loading, title, disabled }) => {
  const methods = useFormContext();
  const dispatch = useDispatch();
  const [modalCustomerType, setModalCustomerType] = useState(undefined);

  const columns = useMemo(
    () => [
      {
        header: 'Tên loại khách hàng',
        accessor: 'customer_type_name',
      },
      {
        header: 'Công ty áp dụng',
        accessor: 'company_name',
      },
      {
        header: 'Chi nhánh áp dụng',
        accessor: 'business_name',
      },
    ],
    [],
  );

  const actions = useMemo(() => {
    return [
      {
        globalAction: true,
        icon: ICON_COMMON.add,
        type: 'success',
        content: 'Chọn khách hàng',
        permission: COUPON_PERMISSION.SELECT_CUSTOMER_TYPE,
        hidden: disabled,
        onClick: () => {
          setModalCustomerType(true);
        },
      },
      {
        icon: ICON_COMMON.trash,
        color: 'red',
        hidden: disabled,
        permission: COUPON_PERMISSION.SELECT_CUSTOMER_TYPE,
        onClick: (value) => {
          dispatch(
            showConfirmModal([`Xoá ${value?.customer_type_name} ra khỏi danh sách khách hàng áp dụng ?`], () => {
              const customer_type_list = _.cloneDeep(methods.watch('customer_type_list'));
              methods.setValue(
                'customer_type_list',
                customer_type_list.filter((o) => parseInt(o?.customer_type_id) !== parseInt(value?.customer_type_id)),
              );
              return;
            }),
          );
        },
      },
    ];
  }, []);

  return (
    <React.Fragment>
      <BWAccordion title={title}>
        <div className='bw_frm_box'>
          <div className='bw_col_12'>
            <div className='bw_align_items_center bw_lb_sex bw_col_12'>
              <label className='bw_checkbox'>
                <FormInput disabled={disabled} type='checkbox' field='is_all_customer_type' />
                <span />
                Áp dụng với tất cả loại khách hàng
              </label>
            </div>
            {!Boolean(methods.watch('is_all_customer_type')) && (
              <DataTable
                hiddenActionRow
                noPaging
                noSelect
                loading={loading}
                data={methods.watch('customer_type_list')}
                columns={columns}
                actions={actions}
              />
            )}
          </div>
        </div>
      </BWAccordion>
      {modalCustomerType && (
        <CouponCustomerTypeModal
          open={modalCustomerType}
          onClose={() => {
            methods.unregister('keyword');
            setModalCustomerType(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

CouponCustomerType.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CouponCustomerType;
